import { render, staticRenderFns } from "./WindCompass.vue?vue&type=template&id=1439dbc0&scoped=true&"
import script from "./WindCompass.vue?vue&type=script&lang=js&"
export * from "./WindCompass.vue?vue&type=script&lang=js&"
import style0 from "./WindCompass.vue?vue&type=style&index=0&id=1439dbc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439dbc0",
  null
  
)

export default component.exports